import React from 'react';
import Box from '../../components/Box/Box';

const Form = (props) => <Box {...props} as="form" name="Form" />;

export default Form;
